import { authApi } from '../services/auth_endpoints';

// Session state is sourced from the getCurrentUser (GET /users/me) query cache —
// there is no auth slice. `.select()` (arg `undefined`, matching how the app
// bootstraps the query) yields a memoized selector for that cache entry.
const selectCurrentUserResult = authApi.endpoints.getCurrentUser.select();

export const selectUser = (state) => selectCurrentUserResult(state)?.data ?? null;
export const selectAuthenticated = (state) => !!selectCurrentUserResult(state)?.data;

// Tri-state session status so consumers can tell "still loading /me" apart from
// "resolved, logged out" — needed now that the app renders before /me settles
// (no blocking splash). 'loading' until the request settles, then
// 'authenticated' (user present) or 'anonymous' (401 / no user).
export const selectAuthStatus = (state) => {
  const result = selectCurrentUserResult(state);
  if (result?.data) return 'authenticated';
  if (!result || result.status === 'uninitialized' || result.status === 'pending') return 'loading';
  return 'anonymous';
};
export const selectCurrentUserPermissions = (customerId, permission) => (state) => {
  const user = selectUser(state);
  if (!user || !customerId) return null;
  const customerKey = parseInt(customerId, 10);
  return user.managedCustomers.filter(c => c.id === customerKey)[0]?.permissions[permission] || null;
};
export const selectUserIsVerified = (state) => selectUser(state)?.isVerified;
